import FinancingPopover from './financing-popover'

export const AmuiFinancingPopover = FinancingPopover

export default Vue => Vue.component(FinancingPopover.name, FinancingPopover)
